module.exports = __webpack_public_path__ + "img/AI-Based-Custom-Solutions.4697e35b.webp";